<template>
    <div>
        <div class="settings_right mb-5" v-if="callFromPetition == false || (callFromPetition && checkProperty(petition, 'overviewInfo') && checkProperty(petition, 'overviewInfo', 'beneficiaryInfo'))">
            <template v-if="callFromPetition == false || (callFromPetition && checkProperty(petition, 'overviewInfo') && checkProperty(petition, 'overviewInfo', 'beneficiaryInfo')
            && (checkProperty(petition['overviewInfo'], 'beneficiaryInfo', 'currentStatus') || checkProperty(petition['overviewInfo'], 'beneficiaryInfo', 'statusExpiryDate') 
            ||checkProperty(petition['overviewInfo'], 'beneficiaryInfo', 'I94') || checkProperty(petition['overviewInfo'], 'beneficiaryInfo', 'I94ExpiryDate')
            || checkProperty(petition['overviewInfo'], 'beneficiaryInfo', 'alienNumber') || checkProperty(petition['overviewInfo'], 'beneficiaryInfo', 'sevisNumber') 
            || checkProperty(petition['overviewInfo'], 'beneficiaryInfo', 'passportNumber') || checkProperty(petition['overviewInfo'], 'beneficiaryInfo', 'passportExpiryDate')
            || checkProperty(petition['overviewInfo'], 'beneficiaryInfo', 'I797ExpiryDate') || checkProperty(petition['overviewInfo'], 'beneficiaryInfo', 'I129sExpiryDate') 
            || checkProperty(petition['overviewInfo'], 'beneficiaryInfo', 'PERMFiledDate') || checkProperty(petition['overviewInfo'], 'beneficiaryInfo', 'i140DeadlineDate')))">
                <h3 class="small-header main_head">Important Dates</h3>
                <div class="form_section overview_section mobi">
                    <div class="form-container"> 
                        <!-- <h3 class="small-header">US Current Status </h3>  priorToExpiryDaysH1b -->
                        <form  @submit.prevent data-vv-scope="casedetailsform">
                            <template v-if="callFromPetition">
                                <div class="vx-row">
                                    <div class="vs-col w-1/3" v-if="checkProperty(petition['overviewInfo'], 'beneficiaryInfo', 'currentStatus')"> 
                                        <selectField :wrapclass="'w-full'" :display="true" :optionslist="visastatuses"
                                        :required="checkProperty(petition['overviewInfo'], 'beneficiaryInfo', 'currentStatus')?true:false"  
                                        @input="beneficiaryInfo.currentStatus = beneficiaryInfo.currentStatusDetails && beneficiaryInfo.currentStatusDetails.id?beneficiaryInfo.currentStatusDetails.id:'';checkCurrentStatus()"
                                        v-model="beneficiaryInfo.currentStatusDetails" :fieldName="'currentStatus'"  formscope="casedetailsform"  label="Current Status" vvas="Current Status" placeholder="Current Status" />
                                    </div>
                                    <div class="vs-col w-1/3" v-if="checkProperty(petition['overviewInfo'], 'beneficiaryInfo', 'statusExpiryDate')"> 
                                        <template v-if="[3].indexOf(getUserRoleId)>-1">
                                            <template v-if="checkReminderExists('priorToExpiryDaysH1b')">
                                                <span class="ds_check" @click="openReminder('priorToExpiryDaysH1b', beneficiaryInfo.statusExpiryDate)">View Reminder </span>
                                            </template>
                                            <template v-else>
                                                <span class="ds_check" @click="redirectReminder()">Update Reminder </span>
                                            </template>
                                        </template>
                                        <datepickerField :wrapclass="'w-full'" :isDisabled="!beneficiaryInfo.currentStatus" :display="true" :dateEnableFrom="new Date()"
                                         :validationRequired="checkProperty(petition['overviewInfo'], 'beneficiaryInfo', 'statusExpiryDate')?true:false" v-model="beneficiaryInfo.statusExpiryDate" :fieldName="'statusExpiryDate'"  formscope="casedetailsform"  label="Status Expiration Date" />
                                    </div>
                                    <div class="vs-col w-1/3" v-if="checkProperty(petition['overviewInfo'], 'beneficiaryInfo', 'I94')">
                                        <immiInput :wrapclass="'w-full'" @input="updateVal('I94')" :allowUpperCase="true" :display="false"  cid="benI94" datatype="max:15" formscope="casedetailsform" v-model="beneficiaryInfo.I94"   :fieldName="'I94'" 
                                         :required="(checkProperty(petition['overviewInfo'], 'beneficiaryInfo', 'I94') || beneficiaryInfo.I94)?true:false"  label="I-94 Number" placeHolder="I-94 Number" />                                                
                                    </div>
                                    <div class="vs-col w-1/3" v-if="checkProperty(petition['overviewInfo'], 'beneficiaryInfo', 'I94ExpiryDate')">
                                        <template v-if="[3].indexOf(getUserRoleId)>-1">
                                            <template v-if="checkReminderExists('i94Expiry')">
                                                <span class="ds_check" @click="openReminder('i94Expiry', beneficiaryInfo.I94ExpiryDate)">View Reminder </span>
                                            </template>
                                            <template v-else>
                                                <span class="ds_check" @click="redirectReminder()">Update Reminder </span>
                                            </template>
                                        </template>
                                        <datepickerField :wrapclass="'w-full'" :isDisabled="!beneficiaryInfo.I94" :display="true" :dateEnableFrom="new Date()"
                                         :validationRequired="checkProperty(petition['overviewInfo'], 'beneficiaryInfo', 'I94ExpiryDate')?true:false"
                                        v-model="beneficiaryInfo.I94ExpiryDate" :fieldName="'I94ExpiryDate'"  formscope="casedetailsform"  label="I-94 Expiration Date" />
                                    </div>
                                    <div class="vs-col w-1/3" v-if="checkProperty(petition['overviewInfo'], 'beneficiaryInfo', 'alienNumber')">
                                        <immiInput :wrapclass="'w-full'" :required="checkProperty(petition['overviewInfo'], 'beneficiaryInfo', 'alienNumber')?true:false"
                                        :display="true" datatype="alpha_num|max:9" cid="benfalienNumber_alienNumber" formscope="casedetailsform" v-model="beneficiaryInfo.alienNumber"  :fieldName="'alienNumber'"   label="Alien Number (A#)" placeHolder="Alien Number (A#)" />
                                    </div>
                                    <div class="vs-col w-1/3" v-if="checkProperty(petition['overviewInfo'], 'beneficiaryInfo', 'sevisNumber')">
                                        <immiInput :wrapclass="'w-full'" :required="checkProperty(petition['overviewInfo'], 'beneficiaryInfo', 'sevisNumber')?true:false"
                                        :allowUpperCase="true" :display="true"  datatype="alpha_num|max:15" cid="benfsevisNumber" formscope="casedetailsform" v-model="beneficiaryInfo.sevisNumber"  :fieldName="'sevisNumber'"    label="SEVIS  Number" placeHolder="SEVIS  Number" />
                                    </div> 
                                    <div class="vs-col w-1/3" v-if="checkProperty(petition['overviewInfo'], 'beneficiaryInfo', 'passportNumber')">
                                        <immiInput :wrapclass="'w-full'" @input="updateVal('passportNumber')" :allowUpperCase="true" :display="true" :tplkey="'passportNumber'" datatype="alpha_num|max:15" cid="benfpassportNumber" formscope="casedetailsform" v-model="beneficiaryInfo.passportNumber" :fieldName="'passportNumber'" 
                                         :required="(checkProperty(petition['overviewInfo'], 'beneficiaryInfo', 'passportNumber') || beneficiaryInfo.passportNumber)?true:false"  label="Passport Number" placeHolder="Passport Number" />
                                    </div>
                                    <div class="vs-col w-1/3" v-if="checkProperty(petition['overviewInfo'], 'beneficiaryInfo', 'passportExpiryDate')">
                                        <template v-if="[3].indexOf(getUserRoleId)>-1">
                                            <template v-if="checkReminderExists('passportExpiry')">
                                                <span class="ds_check" @click="openReminder('passportExpiry', beneficiaryInfo.passportExpiryDate)">View Reminder </span>
                                            </template>
                                            <template v-else>
                                                <span class="ds_check" @click="redirectReminder()">Update Reminder </span>
                                            </template> 
                                        </template>
                                        <datepickerField :wrapclass="'w-full'" :isDisabled="!beneficiaryInfo.passportNumber" :display="true" :tplkey="'passportExpiryDate'"  :dateEnableFrom="new Date()"
                                         :validationRequired="checkProperty(petition['overviewInfo'], 'beneficiaryInfo', 'passportExpiryDate')?true:false" v-model="beneficiaryInfo.passportExpiryDate" :fieldName="'passportExpiryDate'"  formscope="casedetailsform"  label="Passport Expiration Date" />
                                    </div>
                                    <div class="vs-col w-1/3" v-if="checkProperty(petition['overviewInfo'], 'beneficiaryInfo', 'I797ExpiryDate')">
                                        <template v-if="[3].indexOf(getUserRoleId)>-1">
                                            <template v-if="checkReminderExists('priorToExpiryDaysH1b')">
                                                <span class="ds_check" @click="openReminder('priorToExpiryDaysH1b', beneficiaryInfo.I797ExpiryDate)">View Reminder </span>
                                            </template>
                                            <template v-else>
                                                <span class="ds_check" @click="redirectReminder()">Update Reminder </span>
                                            </template>
                                        </template>
                                        <datepickerField :wrapclass="'w-full'" :display="true" :tplkey="'I797ExpiryDate'"  :dateEnableFrom="new Date()"
                                         :validationRequired="checkProperty(petition['overviewInfo'], 'beneficiaryInfo', 'I797ExpiryDate')?true:false" v-model="beneficiaryInfo.I797ExpiryDate" :fieldName="'I797ExpiryDate'"  formscope="casedetailsform"  label="I-797 Expiration Date" />
                                    </div>
                                    <div class="vs-col w-1/3" v-if="checkProperty(petition['overviewInfo'], 'beneficiaryInfo', 'I129sExpiryDate')">
                                        <template v-if="[3].indexOf(getUserRoleId)>-1">
                                            <template v-if="checkReminderExists('priorToExpiryDaysH1b')">
                                                <span class="ds_check" @click="openReminder('priorToExpiryDaysH1b', beneficiaryInfo.I129sExpiryDate)">View Reminder </span>
                                            </template>
                                            <template v-else>
                                                <span class="ds_check" @click="redirectReminder()">Update Reminder </span>
                                            </template>
                                        </template>
                                        <datepickerField :wrapclass="'w-full'" :display="true" :tplkey="'I129sExpiryDate'"  :dateEnableFrom="new Date()" 
                                        :validationRequired="checkProperty(petition['overviewInfo'], 'beneficiaryInfo', 'I129sExpiryDate')?true:false" v-model="beneficiaryInfo.I129sExpiryDate" :fieldName="'I129sExpiryDate'"  formscope="casedetailsform"  label="I-129S Expiration Date" />
                                    </div>
                                </div>
                            </template>
                            <template v-else>
                                <div class="vx-row">        
                                    <div class="vs-col w-1/3"> 
                                        <selectField :wrapclass="'w-full'" :display="true"  :optionslist="visastatuses" 
                                        :required="checkProperty(petition['overviewInfo'], 'beneficiaryInfo', 'currentStatus')?true:false"  
                                        @input="beneficiaryInfo.currentStatus = beneficiaryInfo.currentStatusDetails && beneficiaryInfo.currentStatusDetails.id?beneficiaryInfo.currentStatusDetails.id:'';checkCurrentStatus()"
                                        v-model="beneficiaryInfo.currentStatusDetails" :fieldName="'currentStatus'"  formscope="casedetailsform"  label="Current Status" vvas="Current Status" placeholder="Current Status" />
                                    </div>
                                    <div class="vs-col w-1/3"> 
                                        <template v-if="[3].indexOf(getUserRoleId)>-1">
                                            <template v-if="checkReminderExists('priorToExpiryDaysH1b')">
                                                <span class="ds_check" @click="openReminder('priorToExpiryDaysH1b', beneficiaryInfo.statusExpiryDate)">View Reminder </span>
                                            </template>
                                            <template v-else>
                                                <span class="ds_check" @click="redirectReminder()">Update Reminder </span>
                                            </template>
                                        </template>
                                        <datepickerField :wrapclass="'w-full'" :isDisabled="!beneficiaryInfo.currentStatus" :display="true" :dateEnableFrom="new Date()" 
                                        :validationRequired="checkProperty(petition['overviewInfo'], 'beneficiaryInfo', 'statusExpiryDate')?true:false"
                                         v-model="beneficiaryInfo.statusExpiryDate" :fieldName="'statusExpiryDate'"  formscope="casedetailsform"  label="Status Expiration Date" />
                                    </div>
                                </div>
                                <div class="vx-row overview_row" >
                                    <div class="vs-col w-1/3">
                                        <immiInput :wrapclass="'w-full'" :showMandotry="false" @input="updateVal('I94')" :allowUpperCase="true" :display="false"  cid="benI94" datatype="max:15" formscope="casedetailsform" v-model="beneficiaryInfo.I94"   :fieldName="'I94'" 
                                        :required="(checkProperty(petition['overviewInfo'], 'beneficiaryInfo', 'I94') || beneficiaryInfo.I94)?true:false"  label="I-94 Number" placeHolder="I-94 Number" />                                                
                                    </div>
                                    <div class="vs-col w-1/3">
                                        <template v-if="[3].indexOf(getUserRoleId)>-1">
                                            <template v-if="checkReminderExists('i94Expiry')">
                                                <span class="ds_check" @click="openReminder('i94Expiry', beneficiaryInfo.I94ExpiryDate)">View Reminder </span>
                                            </template>
                                            <template v-else>
                                                <span class="ds_check" @click="redirectReminder()">Update Reminder </span>
                                            </template>
                                        </template>
                                        <datepickerField :wrapclass="'w-full'" :isDisabled="!beneficiaryInfo.I94" 
                                        :display="true" :dateEnableFrom="new Date()" :validationRequired="checkProperty(petition['overviewInfo'], 'beneficiaryInfo', 'I94ExpiryDate')?true:false"
                                        v-model="beneficiaryInfo.I94ExpiryDate" :fieldName="'I94ExpiryDate'"  formscope="casedetailsform"  label="I-94 Expiration Date" />
                                    </div>
                                </div>
                                <div class="vx-row">
                                    <div class="vs-col w-1/3">
                                        <immiInput :wrapclass="'w-full'" :display="true" datatype="alpha_num|max:9" cid="benfalienNumber_alienNumber" formscope="casedetailsform" v-model="beneficiaryInfo.alienNumber"  :fieldName="'alienNumber'" 
                                        :required="checkProperty(petition['overviewInfo'], 'beneficiaryInfo', 'alienNumber')?true:false"  label="Alien Number (A#)" placeHolder="Alien Number (A#)" />
                                    </div>
                                    <div class="vs-col w-1/3">
                                        <immiInput :wrapclass="'w-full'" :allowUpperCase="true" :display="true"  datatype="alpha_num|max:15" cid="benfsevisNumber" formscope="casedetailsform" v-model="beneficiaryInfo.sevisNumber" 
                                        :required="checkProperty(petition['overviewInfo'], 'beneficiaryInfo', 'sevisNumber')?true:false" :fieldName="'sevisNumber'"    label="SEVIS  Number" placeHolder="SEVIS  Number" />
                                    </div>
                                </div>
                                <div class="vx-row overview_row">
                                    <div class="vs-col w-1/3">
                                    <immiInput :wrapclass="'w-full'"  @input="updateVal('passportNumber')" :allowUpperCase="true" :display="true" :tplkey="'passportNumber'" datatype="alpha_num|max:15" cid="benfpassportNumber" formscope="casedetailsform" v-model="beneficiaryInfo.passportNumber" :fieldName="'passportNumber'" 
                                     :required="(checkProperty(petition['overviewInfo'], 'beneficiaryInfo', 'passportNumber') || beneficiaryInfo.passportNumber)?true:false"  label="Passport Number" placeHolder="Passport Number" />
                                    </div>
                                    <div class="vs-col w-1/3"> 
                                        <template v-if="[3].indexOf(getUserRoleId)>-1">
                                            <template v-if="checkReminderExists('passportExpiry')">
                                                <span class="ds_check" @click="openReminder('passportExpiry', beneficiaryInfo.passportExpiryDate)">View Reminder </span>
                                            </template>
                                            <template v-else>
                                                <span class="ds_check" @click="redirectReminder()">Update Reminder </span>
                                            </template>
                                        </template>
                                        <datepickerField :wrapclass="'w-full'" :isDisabled="!beneficiaryInfo.passportNumber"  :display="true" :tplkey="'passportExpiryDate'"  :dateEnableFrom="new Date()"
                                         :validationRequired="checkProperty(petition['overviewInfo'], 'beneficiaryInfo', 'passportExpiryDate')?true:false" v-model="beneficiaryInfo.passportExpiryDate" :fieldName="'passportExpiryDate'"  formscope="casedetailsform"  label="Passport Expiration Date" />
                                    </div>
                                </div>
                                <div class="vx-row">
                                    <div class="vs-col w-1/3">
                                        <template v-if="[3].indexOf(getUserRoleId)>-1">
                                            <template v-if="checkReminderExists('priorToExpiryDaysH1b')">
                                                <span class="ds_check" @click="openReminder('priorToExpiryDaysH1b', beneficiaryInfo.I797ExpiryDate)" >View Reminder </span>
                                            </template>
                                            <template v-else>
                                                <span class="ds_check" @click="redirectReminder()">Update Reminder </span>
                                            </template>
                                        </template>
                                        <datepickerField :wrapclass="'w-full'" :display="true" :tplkey="'I797ExpiryDate'"  :dateEnableFrom="new Date()" 
                                        :validationRequired="checkProperty(petition['overviewInfo'], 'beneficiaryInfo', 'I797ExpiryDate')?true:false" v-model="beneficiaryInfo.I797ExpiryDate" :fieldName="'I797ExpiryDate'"  formscope="casedetailsform"  label="I-797 Expiration Date" />
                                    </div>
                                    <div class="vs-col w-1/3">
                                        <template v-if="[3].indexOf(getUserRoleId)>-1">
                                            <template v-if="checkReminderExists('priorToExpiryDaysH1b')">
                                                <span class="ds_check" @click="openReminder('priorToExpiryDaysH1b', beneficiaryInfo.I129sExpiryDate)" >View Reminder </span>
                                            </template>
                                            <template v-else>
                                                <span class="ds_check" @click="redirectReminder()">Update Reminder </span>
                                            </template>
                                        </template>
                                        <datepickerField :wrapclass="'w-full'" :display="true" :tplkey="'I129sExpiryDate'"  :dateEnableFrom="new Date()" 
                                        :validationRequired="checkProperty(petition['overviewInfo'], 'beneficiaryInfo', 'I129sExpiryDate')?true:false" v-model="beneficiaryInfo.I129sExpiryDate" :fieldName="'I129sExpiryDate'"  formscope="casedetailsform"  label="I-129S Expiration Date" />
                                    </div>
                                </div>
                            </template>
                                <template v-if="callFromPetition == false || (callFromPetition && checkProperty(petition, 'overviewInfo') && checkProperty(petition, 'overviewInfo', 'beneficiaryInfo'))">
                                    <template v-if="callFromPetition == false || 
                                    (callFromPetition && 
                                    (checkProperty(petition['overviewInfo'], 'beneficiaryInfo', 'PERMFiledDate') || checkProperty(petition['overviewInfo'], 'beneficiaryInfo', 'i140DeadlineDate')))">
                                        <span class="divider mt-3 mb-5"></span>
                                        <h3 class="small-header">PERM/I-140</h3>
                                        <div class="vx-row"> 
                                            <div class="vs-col w-1/3" v-if="callFromPetition == false || (callFromPetition && checkProperty(petition['overviewInfo'], 'beneficiaryInfo', 'PERMFiledDate'))">
                                                <template v-if="[3].indexOf(getUserRoleId)>-1">
                                                    <template v-if="checkReminderExists('i140ApprovedDuringDays')">
                                                        <span class="ds_check" @click="openReminder('i140ApprovedDuringDays', beneficiaryInfo.PERMFiledDate)" >View Reminder </span>
                                                    </template>
                                                    <template v-else>
                                                        <span class="ds_check" @click="redirectReminder()">Update Reminder </span>
                                                    </template>
                                                </template>
                                                <datepickerField :wrapclass="'md:w-full'"  :display="true" :tplkey="'PERMFiledDate'"
                                                 :validationRequired="checkProperty(petition['overviewInfo'], 'beneficiaryInfo', 'PERMFiledDate')?true:false" v-model="beneficiaryInfo.PERMFiledDate" :fieldName="'PERMFiledDate'"  
                                                formscope="casedetailsform"  label="PERM Filing Date / Priority Date" />
                                                                                       
                                            </div>
                                            <div class="vs-col w-1/3" v-if="callFromPetition == false || (callFromPetition && checkProperty(petition['overviewInfo'], 'beneficiaryInfo', 'i140DeadlineDate'))">
                                                <template v-if="[3].indexOf(getUserRoleId)>-1">
                                                    <template v-if="checkReminderExists('priorToExpiryPermDays')">
                                                        <span class="ds_check" @click="openReminder('priorToExpiryPermDays', beneficiaryInfo.i140DeadlineDate)" >View Reminder </span>
                                                    </template>
                                                    <template v-else>
                                                        <span class="ds_check" @click="redirectReminder()">Update Reminder </span>
                                                    </template>
                                                </template>
                                                <datepickerField :wrapclass="'md:w-full'"
                                                :display="true" :tplkey="'i140DeadlineDate'"  :dateEnableFrom="new Date()" 
                                                :validationRequired="checkProperty(petition['overviewInfo'], 'beneficiaryInfo', 'i140DeadlineDate')?true:false" v-model="beneficiaryInfo.i140DeadlineDate" :fieldName="'i140DeadlineDate'"  formscope="casedetailsform"  label="I-140 Filing Deadline Date " />
                                            
                                                                                       
                                            </div>
                                            <template v-if="false">
                                                <datepickerField :wrapclass="'md:w-1/3'"  
                                                :display="true" :tplkey="'PERMFiledDate'" :validationRequired="false" v-model="beneficiaryInfo.PERMFiledDate" :fieldName="'PERMFiledDate'"  
                                                formscope="casedetailsform"  label="PERM Filing Date / Priority Date" />
                                                <datepickerField :wrapclass="'md:w-1/3'" v-if="callFromPetition == false || (callFromPetition && checkProperty(petition['overviewInfo'], 'beneficiaryInfo', 'i140DeadlineDate'))"
                                                :display="true" :tplkey="'i140DeadlineDate'"  :dateEnableFrom="new Date()" :validationRequired="false" v-model="beneficiaryInfo.i140DeadlineDate" :fieldName="'i140DeadlineDate'"  formscope="casedetailsform"  label="I-140 Filing Deadline Date " />
                                                <!-- priorToExpiryPermDays -->
                                                <datepickerField :wrapclass="'md:w-1/3'" v-if="false && callFromPetition == false || (callFromPetition && checkProperty(petition['overviewInfo'], 'beneficiaryInfo', 'i130DeadlineDate'))"
                                                :display="true" :tplkey="'i130DeadlineDate'"  :dateEnableFrom="new Date()" :validationRequired="false" v-model="beneficiaryInfo.i130DeadlineDate" :fieldName="'i130DeadlineDate'"  formscope="casedetailsform"  label="I-130 Filing Deadline Date " />
                                            </template>
                                        </div>
                                    </template>
                                </template>
                        </form>
                        <div class="form-footer">
                            <button class="save" :disabled="formSubmited" @click="submitForm()">
                                Update
                            </button>
                        </div>
                    </div>
                </div>
            </template>
        </div>
        <div class="settings_right mb-5">
            <h3 class="small-header main_head">Global Status 
                <span v-if="checkReminderExists('globalStatus')" class="view_remainder" @click="openReminder('globalStatus')" >View Reminder </span> 
                <span v-else class="view_remainder" @click="redirectReminder()">Update Reminder </span>
            </h3>
            
            <div class="form_section overview_section mobi">
                <div class="form-container">
                    <form  @submit.prevent data-vv-scope="globalStatusform">
                        <template v-for="(item, ind) in globalStatus"> 
                        <div class="vx-row global_staus" :class="{'global_staus_ben':callFromPetition}">                            
                                <div class="vs-col w-1/2 col4"> 
                                    <selectField :wrapclass="'w-full'" :display="true" :required="true" :optionslist="filteredCountries" 
                                    @input="item.travelCountryId = item.travelCountryDetails.id;updateCountryList()"
                                    v-model="item.travelCountryDetails" :fieldName="'travelCountryDetails'+ind"  
                                    formscope="globalStatusform"  label="Country Travelled" vvas="Country Travelled" placeholder="Country Travelled" />
                                </div>
                                <div class="vs-col w-1/2 col4">
                                    <immiInput :wrapclass="'w-full'" :display="true" 
                                     cid="benfpassportNumber" formscope="globalStatusform" v-model="item.visaStatus" 
                                     :fieldName="'visaStatus'+ind"  :required="true"  
                                     label="Visa Status" placeHolder="Visa Status" />

                                </div>
                                <div class="vs-col w-1/2 col4">
                                    <datepickerField :wrapclass="'w-full'" @input="clearStatusDates(item, ind)"
                                    :display="true" :validationRequired="true"
                                    v-model="item.validFrom" :fieldName="'validFrom'+ind"  formscope="globalStatusform"  label="Valid From" />
                                </div>
                                <div class="vs-col w-1/2 col4"> 
                                    
                                    <datepickerField :wrapclass="'w-full'" :isDisabled="!item.validFrom" 
                                    :display="true" :dateEnableFrom="item.validFrom" :validationRequired="true" 
                                    v-model="item.validTo" :fieldName="'validTo'+ind"  formscope="globalStatusform"  label="Valid To" />
                                </div>
                                <div class="delete" @click="removeStatus(ind);updateCountryList()" v-if="checkProperty(globalStatus, 'length')>1">
                                    <a>
                                        <img src="@/assets/images/main/delete-row-img.svg">
                                    </a>
                                </div>                            
                        </div>
                    </template>
                        <a class="add-more add-more-names ml-0 mt-0" @click="addStatus();updateCountryList()"><span>+</span>Add</a>

                    </form>
                    <div class="form-footer">
                        <button class="save" :disabled="globalFormSubmited" @click="submitGlobalForm()">
                            Update
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <div class="settings_right" v-if="overallVisaInfo && overallVisaInfo.length > 0 && overallVisaInfo[0].visaStatus!=null">
            <h3 class="small-header main_head">Period of Stay in Status  <span class="span_head" v-if="totalDays > 0">Total No. of Days: <label>{{ totalDays }}</label></span> </h3>

           

            <div class="form_section overview_section pt-0">
                <div class=" main-list-wrap petition_details_wrap">
                    <div class="tabs-content-table mt-2 priorPeriodtable " v-if="overallVisaInfo && overallVisaInfo.length > 0 && overallVisaInfo[0].visaStatus!=null">
                        <div class="">
                            <vs-table :data="overallVisaInfo"> 
                                <template>
                                    <template slot="thead">
                                        <vs-th>Status</vs-th>
                                        <vs-th>Duration</vs-th>
                                        <vs-th>No. of Days</vs-th>
                                    </template>
                                    <template>
                                        <vs-tr :key="sin" v-for="(stay ,sin) in overallVisaInfo">
                                            <vs-td> {{ stay.visaStatus  | formatML(visastatuses)}}</vs-td>
                                            <vs-td>
                                            <template v-if="stay.fromDate">{{stay.fromDate | formatDate}} - 
                                                <template v-if="stay.toDate">{{stay.toDate | formatDate}}</template> 
                                                <template v-else>Till Date</template>
                                            </template>
                                            </vs-td>
                                            <vs-td>
                                                <template v-if="stay.fromDate && stay.toDate">
                                                    {{ calculateDayDiff(stay.fromDate, stay.toDate) }}
                                                </template>
                                                <template v-else>
                                                    N/A
                                                </template>
                                            </vs-td>
                                        </vs-tr>
                                    </template>
                                </template>
                            </vs-table>
                        </div>
                    </div>
                </div>
            </div>        
        </div>
        <modal name="showReminderDetailsModal" classes="v-modal-sec" :min-width="200" :min-height="200" :scrollable="true"
            :reset="true" width="650px" height="auto">
            <div class="v-modal profile_details_modal expiry_remainder error-modal-space">
                <div class="popup-header fromDetailsPage">
                    <h2 class="popup-title"> {{getReminderTitle}} </h2>
                    <span @click="reminderCategoryDetails=null;$modal.hide('showReminderDetailsModal')">
                        <em class="material-icons">close</em>
                    </span>
                </div>
                <span v-if="remiderData && remiderCategory != 'globalStatus'&&checkProperty(reminderCategoryDetails, 'length')>0"> 
                    <vs-alert v-if="checkProperty(reminderCategoryDetails[0], 'reminder')" color="warning" class="warning-alert top-warning-alert" icon-pack="IntakePortal" icon="IP-information-button" active="true">
                            {{checkProperty(reminderCategoryDetails[0],'reminder')}}                   
                    </vs-alert> 
                </span>
                <div class="form-container">
                    <div  class="history-sidebar petition_history activies_list">
                        
                                    
                                
                        <div class="vs-sidebar">
                            <!-- <fileUploadNote :fileNote="false" :ShowMessage="true" :messag="'Reminder'" /> -->
                            <div class="edit_btn_list"> 
                                <span v-if="showDetails" class="items_edit" @click="showDetails = false">
                                    <img src="@/assets/images/main/icon-edit.svg" />Edit
                                </span>
                            </div>
                            <div class="vs-sidebar--items" v-if="showDetails">
                                <VuePerfectScrollbar class="scroll-area">
                                    <div class="timeline-sidebar 2">
                                        <ul>
                                            <li v-for="(item, index) in reminderCategoryDetails" :key="index">
                                                <template v-if="checkProperty(item, 'reminders') && checkProperty(item, 'reminders', 'length')>0">
                                                    
                                                    <span class="timeline_heading" v-if="checkProperty(item, 'countryDetails') && checkProperty(item, 'countryDetails', 'name')">
                                                       {{ checkProperty(item, 'countryDetails', 'name') }}
                                                    </span>
                                                     
                                                    <template v-for="(itm, inde) in item['reminders']" >
                                                        <div class="exp_reaminder_list"> 
                                                        <div class="timeline-icon">
                                                            <i class="icon IP-tick-sign"></i>
                                                        </div>
                                                        <div class="timeline-info">                                                             
                                                             <h3><span>{{itm}}</span></h3>                                                            
                                                        </div>
                                                    </div>
                                                    </template>
                                                
                                                </template>
                                            </li>
                                        </ul>
                                    </div>
                                </VuePerfectScrollbar>
                            </div>
                            <template v-else>
                                <template v-if="remiderData && remiderCategory != 'globalStatus'">
                                    <div class="vx-col w-full config_remainders">
                                        <div class="global_sec global_sec1" >
                                            <div class="gbl_status" >
                                                <div class="form_group d-flex align-center w-full ml-4">
                                                    <template v-if="checkProperty(remiderData, 'whoWillSendReminder') && checkProperty(remiderData, 'whoWillSendReminder', 'length')>0">
                                                        <p class="form_label nowrap mb-0">Reminder Send To: 
                                                            <span class="remainder_send">
                                                                <template v-for="(itm, inde) in remiderData['whoWillSendReminder']">
                                                                    <label>{{checkProperty(itm, 'roleName')}}</label>
                                                                </template>
                                                            </span>
                                                        </p>
                                                    </template>
                                                    <template v-if="checkProperty(remiderData, 'roleName') && false">
                                                        <!-- <p class="form_label nowrap mb-0">Reminder Send To: {{ remiderData['roleName'] }}</p> -->
                                                        <p class="form_label nowrap mb-0">Reminder Send To:  
                                                            <span class="remainder_send">
                                                                <label>Beneficiary</label>
                                                                <label>Accountant</label>
                                                                <label>Admin</label> 
                                                                <label>Attorney</label>
                                                            </span>
                                                        </p>    
                                                        
                                                    </template>
                                                    <template v-if="false">
                                                        <multiselect data-vv-as="Send reminder  to"
                                                            v-model="remiderData['whoWillSendReminder']"
                                                            :allow-empty="false" :options="allUserRoles" :multiple="true"
                                                            :close-on-select="false" :clear-on-select="true" :preserve-search="true"
                                                            placeholder="Select" label="name" track-by="id" :preselect-first="false"
                                                            name="sendReminder" :class="'w-auto multi_list_hide'">
                                                            <!-- <template slot="selection" slot-scope="{ values,  isOpen }">
                                                                <span class="multiselect__single"
                                                                    v-if="values.length &amp;&amp; !isOpen">{{ values.length }} options
                                                                    selected</span>
                                                            </template> -->
                                                            <template
                                                                slot="selection"
                                                                slot-scope="{ values, remove  }"
                                                            >
                                                                <span class="multiselect__tags_default" v-if="values.length">
                                                                <div class="multiselect__tags-wrap">
                                                                    <span class="multiselect__tag">
                                                                        <span class="role_name">
                                                                        {{ values[0].roleName }}
                                                                    </span>
                                                                    <i  @click="remove(values[0])" tabindex="1" class="multiselect__tag-icon"></i>
                                                                    </span>
                                                                </div>
                                                                
                                                            <strong v-if="values.length > 1"  class="multiselect__strong">
                                                                    + {{ values.length-1 }}
                                                                </strong>
                                                                </span></template
                                                            >
                                                        </multiselect>
                                                        <span class="text-danger text-sm" v-show="errors.has('sendReminder')">{{
                                                        errors.first("sendReminder") }}</span>
                                                    </template>
                                                </div>
                                            </div>
                                        <form @submit.prevent data-vv-scope="updateForm">
                                            <template
                                                v-for="(item, indexx) in remiderData['config']">
                                                <div class="gbl_status">
                                                    <div class="vx-col w-full">
                                                        <div class="form_group">
                                                            <div class="perm_application_delete">
                                                                <p><vs-input :maxLength="3"
                                                                    :disabled="true"
                                                                        @blur="checkConfigValue(item, indexx)"
                                                                        oninput="this.value = this.value.replace(/[^0-9]/g, '').replace(/(\..*)\./g, '$1'); this.value = this.value.replace(/ /g,'');"
                                                                        class="textfiled" :name="'updateForm' + indexx"
                                                                        icon-pack="feather" v-validate="'required'"
                                                                        data-vv-as="Please enter data" icon-after
                                                                        v-model="item.days" /> days prior to the expiry</p>
                                                                <span v-if="checkProperty(item, 'showError')"
                                                                    class="text-danger text-sm">Days should be less than last entry </span>
                                                                <span class="text-danger text-sm"
                                                                    v-if="errors.has('updateForm.updateForm' + indexx) && !checkProperty(item, 'showError')">
                                                                    Days required </span>
                                                                <div class="delete"
                                                                    v-if="false"
                                                                    @click="removeKeys(indexx)">
                                                                    <a>
                                                                        <img src="@/assets/images/main/delete-row-img.svg" />
                                                                    </a>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </template>
                                            <vs-row class="more_btn_wrap application_btn" v-if="false">
                                                <vs-col class="float-none pr-0 padb10 justify-start more_btn" vs-type="flex"
                                                    vs-align="center">
                                                    <a @click="addMoreKeys('updateForm')" class="add-more ml-0"
                                                        type="filled">
                                                        <span>+</span> More
                                                    </a>
                                                </vs-col>
                                            </vs-row>
                                        </form>
                                        </div>
                                    </div>
                                </template>
                                <template v-else-if="remiderData && remiderCategory == 'globalStatus'">
                                    <template>
                                        <div class="vx-col w-full config_remainders">
                                            <form @submit.prevent data-vv-scope="globalStatus">
                                                <div class="global_sec"> 
                                                    <template>
                                                        <template v-for="(globalItem, ind) in remiderData['config']">
                                                            <div class="gbl_status">
                                                                <div v-if="checkProperty(globalItem,'reminder')"> 
                                                                    <vs-alert color="warning" class="warning-alert top-warning-alert" icon-pack="IntakePortal" icon="IP-information-button" active="true">
                                                                     {{checkProperty(globalItem,'reminder')}}                   
                                                                    </vs-alert><br/>
                                                                </div>
                                                            <div class="form_group d-flex align-center w-full ml-4">
                                                                <template v-if="checkProperty(globalItem, 'countryDetails') && checkProperty(globalItem, 'countryDetails', 'name')">
                                                                    <p class="form_label nowrap mb-0">Country Name: <span class="coun_name"> {{ checkProperty(globalItem, 'countryDetails', 'name') }}</span></p>
                                                                </template>
                                                                <template v-if="false">
                                                                    <multiselect data-vv-as="Country"
                                                                    :disabled="true"
                                                                        v-model="remiderData['config'][ind]['countryDetails']"
                                                                        @input="remiderData['config'][ind]['countryId'] = remiderData['config'][ind]['countryDetails']['id'];updateGlobalCountryList()"
                                                                        :allow-empty="false" :options="filteredGlobalCountries" :multiple="false" v-validate="'required'"
                                                                        :close-on-select="true" :clear-on-select="true" :preserve-search="true"
                                                                        placeholder="Select" label="name" track-by="id" :preselect-first="false"
                                                                        :name="'globalStatus'+ind" :class="'w-auto multi_list_hide'">
                                                                        <template slot="selection" slot-scope="{ values,  isOpen }">
                                                                            <span class="multiselect__single"
                                                                                v-if="values.length &amp;&amp; !isOpen">{{ values.length }} options
                                                                                selected</span>
                                                                        </template>
                                                                    </multiselect>
                                                                    <span class="text-danger text-sm" v-show="errors.has('globalStatus.globalStatus'+ind)">{{
                                                                    errors.first('globalStatus.globalStatus'+ind) }}</span>
                                                                </template>
                                                            </div>
                                                            <template v-for="(item, indexx) in globalItem['config'] ">
                                                                <div class="vx-col w-full">
                                                                    <div class="form_group">
                                                                        <div class="perm_application_delete">
                                                                            <p><vs-input :maxLength="3"
                                                                                :disabled="true"
                                                                                    @blur="checkGlobalValue(item, indexx, ind)"
                                                                                    oninput="this.value = this.value.replace(/[^0-9]/g, '').replace(/(\..*)\./g, '$1'); this.value = this.value.replace(/ /g,'');"
                                                                                    class="textfiled" :name="'globalStatus'+indexx+ind"
                                                                                    icon-pack="feather" v-validate="'required'"
                                                                                    data-vv-as="Please enter data" icon-after
                                                                                    v-model="item.days" /> days prior to the expiry</p>
                                                                            <span v-if="checkProperty(item, 'showError')"
                                                                                class="text-danger text-sm">Days should be less than last entry </span>
                                                                            <span class="text-danger text-sm"
                                                                                v-if="errors.has('globalStatus.globalStatus' + indexx+ind) && !checkProperty(item, 'showError')">
                                                                                Days required </span>
                                                                            <div class="delete" v-if="false && checkProperty(globalItem, 'config', 'length') > 1"
                                                                        
                                                                            @click="removeStatusConfig(ind, indexx, 'globalStatus')">
                                                                                <a>
                                                                                    <img src="@/assets/images/main/delete-row-img.svg" />
                                                                                </a>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </template>

                                                            <vs-row class="more_btn_wrap application_btn" v-if="false">
                                                                <vs-col class="float-none pr-0 padb10 justify-start more_btn" vs-type="flex"
                                                                    vs-align="center">
                                                                    <a @click="addGlobalConfigKeys('globalStatus', ind)" class="add-more ml-0"
                                                                        type="filled">
                                                                        <span>+</span> More
                                                                    </a>
                                                                </vs-col>
                                                            </vs-row>
                                                            <div class="delete_complete" v-if="checkProperty(remiderData, 'config', 'length') > 1 && false"
                                                                @click="removeStatusConfig(ind)">
                                                                <a>
                                                                    <img src="@/assets/images/main/delete-row-img.svg" />
                                                                </a>
                                                            </div>
                                                        </div>
                                                        
                                                        </template>
                                                    </template>
                                                </div>
                                                <vs-row class="more_btn_wrap application_btn" v-if="false">
                                                    <vs-col class="float-none pr-0 padb0 padt20 justify-start more_btn add-country_btn" vs-type="flex"
                                                        vs-align="center">
                                                        <a @click="addGlobalConfigKeys()" class="add-more add-country ml-0"
                                                            type="filled">
                                                            <span>+</span>Add Country
                                                        </a>
                                                    </vs-col>
                                                </vs-row>
                                            </form>
                                        </div>
                                    </template>
                                </template>
                                <div v-show="errorMsg">
                                    <vs-alert color="warning"  class="warning-alert reg-warning-alert no-border-radius" icon-pack="IntakePortal"
                                    icon="IP-information-button" active="true">{{ errorMsg }}</vs-alert>
                                </div>
                               
                            </template>
                        </div>
                    </div>
                </div>
                <div class="popup-footer relative" v-if="false" >
                    <span class="loader" v-if="loading"><img src="@/assets/images/main/loader.gif" /></span>
                    <vs-button color="dark" class="cancel" type="filled" @click="clearReminder()">Cancel </vs-button>
                    <vs-button color="success" class="save" type="filled" @click="updateReminder()">Submit</vs-button>
                </div>
            </div>
        </modal>
    </div>
  </template>
  
  <script>
  import fileUploadNote from "@/views/common/fileUploadNote.vue";
  import moment from "moment";
  import * as _ from "lodash";
  import datepickerField from "@/views/forms/fields/datepicker.vue";
  import selectField from "@/views/forms/fields/simpleselect.vue";
  import immiInput from "@/views/forms/fields/simpleinput.vue";
  import VuePerfectScrollbar from "vue-perfect-scrollbar";
  export default {
    provide() {
      return {
        parentValidator: this.$validator,
      };
    },
    props: {
      visastatuses:null,
      petition:{
        type:Object,
        default:null
      },
      petitionId:{
        type:String,
        default:''
      },
      callFromPetition:{
        type:Boolean,
        default:false
      },
      configDetails:{
        type:Object,
        default:null
      }
    },
    data() {
      return {
        loading:false,
        countries:[],
        filteredGlobalCountries:[],
        showDetails:false,
        passportExpiryUserRoles:[],
        i94ExpiryUserRoles:[],
        visaExpiryUserRoles:[],
        workAuthorizationExpiryUserRoles:[],
        allUserRoles:[],
        remiderData:null,
        globalFormSubmited:false,
        globalStatus:[{
            visaStatus:'',
            travelCountryId: null,
            travelCountryDetails:null,
            validFrom:null,
            validTo:null
        }],
        countries:[],
        filteredCountries:[],
        remiderDate:null,
        remiderCountry:'',
        remiderCategory:'',
        reminderCategoryDetails:null,
        errorMsg:'',
        formSubmited:false, 
        beneficiaryInfo:{
            isDSExpiryDate:false,
            isI94DSExpiryDate:false,
            currentStatus: null,
            currentStatusDetails:null,
            statusExpiryDate:null,
            alienNumber:'',
            sevisNumber:'',
            I94:'',
            I94ExpiryDate:null,
            passportNumber:'',
            passportExpiryDate:null,
            I797ExpiryDate:null,
            I129sExpiryDate:null,
            statusGrantedDate:null,
            firstEntryDateInHorL:null,
            empAuthType:null,
            empAuthExpiryDate:null,
            i140DeadlineDate: null,
            i130DeadlineDate: null,
            PERMFiledDate: null

        }, 
        overallVisaInfo:[],
        dataListwewew: [
            {
                "_id": 0,
                "visaStatus": 3,
                "enteredDate": "Jul 02, 2024 - Oct 02, 2024",
                "departedDate": "N/A"
            },
            {
                "enteredDate": "Oct 02, 2024 - Jan 02, 2024",
                "departedDate": "N/A",
                "visaStatus": 1
            }
        ],
        dataList: [
            {
                "_id": 0,
                "visaStatus": 3,
                "fromDate": "2024-07-02T00:00:00.000Z",
                "toDate": "2024-07-17T00:00:00.000Z"
            },
            {
                "fromDate": "2024-08-01T00:00:00.000Z",
                "toDate": "2024-08-08T00:00:00.000Z",
                "visaStatus": 1
            }
        ],
      }
    },
    watch: {

    },
    mounted() {
        // console.log(JSON.stringify(this.configDetails))
        this.getUserRoles();
        this.$store.dispatch("getcountries").then((response) => {
            this.countries = response;
            this.filteredCountries = response;
            this.filteredGlobalCountries = response;
        });
        if(this.checkProperty(this.petition, 'overviewInfo') && this.checkProperty(this.petition, 'overviewInfo', 'beneficiaryInfo')){
            let benData = _.cloneDeep(this.checkProperty(this.petition, 'overviewInfo', 'beneficiaryInfo'))
            if(this.checkProperty(benData, 'statusExpiryDate')){
                this.beneficiaryInfo['statusExpiryDate'] = this.checkProperty(benData, 'statusExpiryDate')
            }
            if(this.checkProperty(benData, 'currentStatus') && this.checkProperty(this.visastatuses, 'length')>0){
                let findObj = _.find(this.visastatuses,{id:benData['currentStatus']})
                if(findObj){
                    this.beneficiaryInfo['currentStatusDetails'] = findObj
                }
                this.beneficiaryInfo['currentStatus'] =  this.checkProperty(benData, 'currentStatus')
                // this.beneficiaryInfo['currentStatus'] = this.checkProperty(benData, 'currentStatus')
            }
            if(this.checkProperty(benData, 'alienNumber')){
                this.beneficiaryInfo['alienNumber'] = this.checkProperty(benData, 'alienNumber')
            }
            if(this.checkProperty(benData, 'sevisNumber')){
                this.beneficiaryInfo['sevisNumber'] = this.checkProperty(benData, 'sevisNumber')
            }
            if(this.checkProperty(benData, 'I94')){
                this.beneficiaryInfo['I94'] = this.checkProperty(benData, 'I94')
            }
            if(this.checkProperty(benData, 'I94ExpiryDate')){
                this.beneficiaryInfo['I94ExpiryDate'] = this.checkProperty(benData, 'I94ExpiryDate')
            }
            if(this.checkProperty(benData, 'passportNumber')){
                this.beneficiaryInfo['passportNumber'] = this.checkProperty(benData, 'passportNumber')
            }
            if(this.checkProperty(benData, 'passportExpiryDate')){
                this.beneficiaryInfo['passportExpiryDate'] = this.checkProperty(benData, 'passportExpiryDate')
            }
            if(this.checkProperty(benData, 'I797ExpiryDate')){
                this.beneficiaryInfo['I797ExpiryDate'] = this.checkProperty(benData, 'I797ExpiryDate')
            }
            if(this.checkProperty(benData, 'I129sExpiryDate')){
                this.beneficiaryInfo['I129sExpiryDate'] = this.checkProperty(benData, 'I129sExpiryDate')
            }
            if(this.checkProperty(benData, 'statusGrantedDate')){
                this.beneficiaryInfo['statusGrantedDate'] = this.checkProperty(benData, 'statusGrantedDate')
            }
            if(this.checkProperty(benData, 'firstEntryDateInHorL')){
                this.beneficiaryInfo['firstEntryDateInHorL'] = this.checkProperty(benData, 'firstEntryDateInHorL')
            }
            if(this.checkProperty(benData, 'empAuthType')){
                this.beneficiaryInfo['empAuthType'] = this.checkProperty(benData, 'empAuthType')
            }
            if(this.checkProperty(benData, 'empAuthExpiryDate')){
                this.beneficiaryInfo['empAuthExpiryDate'] = this.checkProperty(benData, 'empAuthExpiryDate')
            }
            if(this.checkProperty(benData, 'i140DeadlineDate')){
                this.beneficiaryInfo['i140DeadlineDate'] = this.checkProperty(benData, 'i140DeadlineDate')
            }
            if(this.checkProperty(benData, 'i130DeadlineDate')){
                this.beneficiaryInfo['i130DeadlineDate'] = this.checkProperty(benData, 'i130DeadlineDate')
            }
            if(this.checkProperty(benData, 'PERMFiledDate')){
                this.beneficiaryInfo['PERMFiledDate'] = this.checkProperty(benData, 'PERMFiledDate')
            }
            if(this.checkProperty(benData, 'overallVisaInfo') && this.checkProperty(benData, 'overallVisaInfo', 'length')>0){
                this.overallVisaInfo = this.checkProperty(benData, 'overallVisaInfo')
            }
            if(this.checkProperty(benData, 'globalStatus') && this.checkProperty(benData, 'globalStatus', 'length')>0){
                this.globalStatus = this.checkProperty(benData, 'globalStatus');
                this.updateCountryList();
            }
        }
    },
    computed: {
        checkReminderExists(){
            // visaExpiry, i94Expiry, passportExpiry, globalStatus
            return (data)=>{
                let returnval = false;
                if(data == 'globalStatus'){
                    if(this.checkProperty(this.configDetails, 'reminders') && this.checkProperty(this.configDetails, 'reminders', data) && this.checkProperty(this.configDetails['reminders'], data, 'length')>0){
                        let findObj = this.configDetails['reminders'][data][0];
                        if(findObj && this.checkProperty(findObj, 'countryDetails') && this.checkProperty(findObj, 'countryDetails', 'name')
                        && this.checkProperty(findObj, 'config') && this.checkProperty(findObj, 'config', 'length')>0){
                            returnval = true;
                        }else{
                            returnval = false;
                        }
                    }else{
                        returnval = false;
                    }
                }else{
                    if(this.checkProperty(this.configDetails, 'reminders') && this.checkProperty(this.configDetails, 'reminders', data)){
                        let findObj = this.checkProperty(this.configDetails, 'reminders', data);
                        if(findObj && this.checkProperty(findObj, 'whoWillSendReminder') && this.checkProperty(findObj, 'whoWillSendReminder', 'length')>0 
                        && this.checkProperty(findObj, 'config') && this.checkProperty(findObj, 'config', 'length')>0){
                            returnval = true;
                        }else{
                            returnval = false;
                        }
                    }else{
                        returnval = false;
                    }
                }
                return returnval;
            }
        },
        totalDays() {
            let total = 0;
            this.overallVisaInfo.forEach(stay => {
                if (stay.fromDate && stay.toDate) {
                    total += this.calculateDayDiff(stay.fromDate, stay.toDate);
                }
            });
            return total;
        },
        getReminderTitle(){
            let returnVal = '';
            if(this.remiderCategory == 'i94Expiry'){
                returnVal = 'I-94 Expiry Reminder'
            }
            if(this.remiderCategory == 'passportExpiry'){
                returnVal = 'Passport Expiry Reminder'
                // Travel Document /  
            }
            if(this.remiderCategory == 'priorToExpiryDaysH1b'){
                returnVal = 'Status Expiry Reminder'
            }
            if(this.remiderCategory == 'globalStatus'){
                returnVal = 'Global Status Expiry Reminder'
            }
            if(this.remiderCategory == 'priorToExpiryPermDays'){
                returnVal = 'I-140 Filing Reminder'
            }
            if(this.remiderCategory == 'i140ApprovedDuringDays'){
                returnVal = 'I-485 Filing Reminder'
            }
            return returnVal
        },
    },
    methods: {
        updateVal(category){
            if(category == 'I94'){
                if(!this.beneficiaryInfo.I94){
                    this.beneficiaryInfo.I94ExpiryDate = null;
                }
            }
            if(category == 'passportNumber'){
                if(!this.beneficiaryInfo.passportNumber){
                    this.beneficiaryInfo.passportExpiryDate = null;
                }
            }
        },
        redirectReminder(){
            this.$router.push({ name: 'basic-settings', params: { tabName: 'configReminders'} }).catch(err => {})
        },
        calculateDayDiff(fromDate, toDate) {
            if (!fromDate || !toDate) return 'N/A';
            
            let start = new Date(fromDate);
            let end = new Date(toDate);
            let diffTime = Math.abs(end - start);
            let diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24)); 
            
            return diffDays;
        },
        checkGlobalValue(item, subInd, mainInd) {
            item['showError'] = false;
            this.remiderData['config'][mainInd]['config'][subInd]['showError'] = false;
            let pitem = this.remiderData['config'][mainInd]['config'][subInd - 1];
            if (_.get(pitem, 'days')) {
                let pdays = _.get(pitem, 'days') 
                let minValue = parseInt(pdays) - 1;
                if (minValue > 0) {
                    if (parseInt(item['days']) > parseInt(minValue)) {
                        item['days'] = null;
                        item['showError'] = true;
                    }
                }
            }
        },
        removeStatusConfig(mainInd, subInd, category=''){
            if (category) {
                this.remiderData['config'][mainInd]['config'].splice(subInd, 1);
            }else{
                this.remiderData['config'].splice(mainInd, 1);
            }
            this.updateGlobalCountryList()
        },
        addGlobalConfigKeys(category='', ind){
            this.$validator.validateAll('globalStatus').then((result) => {
                let obj =   {
                    days: '',
                    showError: false,
                }
                let mainObj =   {
                    countryId: null,
                    countryDetails: null,
                    config:[
                        {
                            days: '',
                            showError: false,
                        }
                    ]
                }
                if(result){
                    this.showGlobal = false
                    if(category){
                        this.remiderData['config'][ind]['config'].push(obj);
                        this.remiderData['config']= _.cloneDeep(this.remiderData['config']);
                    }else{
                        this.remiderData['config'].push(mainObj)
                        this.remiderData['config'] = _.cloneDeep(this.remiderData['config']);
                        this.updateGlobalCountryList();
                    }
                    
                }
            })
        },
        updateGlobalCountryList(){//remiderData['config']
            if(this.checkProperty(this.remiderData, 'config', 'length')>0){
                let ids = [];
                _.forEach(this.remiderData['config'], (item)=>{
                    if(item && item['countryDetails'] && item['countryDetails']['id'] ){
                        ids.push(item['countryDetails']['id'])
                    }
                })
                let countryMaster = _.cloneDeep(this.countries);
                if(ids && ids.length>0){
                    let tempList = _.filter(countryMaster, (item)=>{
                        if(ids.indexOf(item['id'])<=-1){
                            return item
                        }
                    })
                    if(tempList){
                        this.filteredGlobalCountries = _.cloneDeep(tempList);
                    }else{
                        this.filteredGlobalCountries = [];
                    }
                    
                }else{
                    this.filteredGlobalCountries = _.cloneDeep(this.countries);
                }
            }else{
                this.filteredGlobalCountries = _.cloneDeep(this.countries);
            }
        },
        checkConfigValue(item, index){
            item['showError'] = false;
            this.remiderData['config'][index]['showError'] = false;
            let pitem = this.remiderData['config'][index - 1];
            if (_.get(pitem, 'days')) {
                let pdays = _.get(pitem, 'days') 
                let minValue = parseInt(pdays) - 1;
                if (minValue > 0) {
                    if (parseInt(item['days']) > parseInt(minValue)) {
                        item['days'] = null;
                        item['showError'] = true;
                        this.remiderData['config'][index]['showError'] = true;
                        this.remiderData['config'][index]['days'] = null;
                    }
                }
            }
        },
        removeKeys(index){
            this.remiderData['config'].splice(index, 1);
        },
        addMoreKeys(){
            this.$validator.validateAll('updateForm').then((result) => {
                if(result){
                    this.remiderData['config'].push(
                        {
                            days: '',
                            showError: false,
                        },
                    );
                }
            })
        },
        updateCountryList(){
            if(this.checkProperty(this.globalStatus, 'length')>0){
                let ids = this.globalStatus.map(item => item.travelCountryId);
                let countryMaster = _.cloneDeep(this.countries);
                if(ids && ids.length>0 &&false){
                    let tempList = _.filter(countryMaster, (item)=>{
                        if(ids.indexOf(item['id'])<=-1){
                            return item
                        }
                    })
                    if(tempList){
                        this.filteredCountries = _.cloneDeep(tempList);
                    }else{
                        this.filteredCountries = [];
                    }
                    
                }else{
                    this.filteredCountries = _.cloneDeep(this.countries);
                }
            }else{
                this.filteredCountries = _.cloneDeep(this.countries);
            }
            
        },
        clearStatusDates(obj, inde){
            if(_.has(obj, 'validFrom') && obj['validFrom'] ){
                let validFrom = moment(obj['validFrom']);
                if(_.has(obj, 'validTo') && obj['validTo'] ){
                    let validTo = moment(obj['validTo']);
                    if(validFrom.isAfter(validTo , 'day')){
                        this.globalStatus[inde].validTo = null;
                    }
                }
            }else{
                this.globalStatus[inde].validTo = null;
            }
        },
        removeStatus(index) {
            this.globalStatus.splice(index, 1);
        },
        addStatus() {
            let item = {
                visaStatus:'',
                travelCountryId: null,
                travelCountryDetails:null,
                validFrom:null,
                validTo:null
            };
            this.$validator.validateAll('globalStatusform').then((result) => {
                if(result){
                    this.globalStatus.push(item);
                }
            })
            
        },
        submitGlobalForm(){
            this.$validator.validateAll('globalStatusform').then((result) => {
                if(result){
                    let payLoad={
                        userId:this.petitionId,
                        overviewInfo:{
                            beneficiaryInfo:{
                                globalStatus:this.globalStatus
                            }
                        }
                    };
                    let path='/beneficiary-profile/update-global-status';
                    this.globalFormSubmited = true;
                    this.errorMsg = '';
                    this.$store.dispatch('commonAction', {data:payLoad, path:path}).then((response)=>{
                        this.globalFormSubmited = false;
                        this.showToster({message:response.message,isError:false });
                        this.$emit('reloadPetition', 'overView')
                        // if(this.callFromPetition){
                            
                        // }
                        
                    }).catch((err)=>{
                        this.globalFormSubmited = false;
                        this.errorMsg = err
                        this.showToster({message:err,isError:true });
                    })
                }
            })
        },
        openReminder(cat='', date='', country=''){
            this.remiderCategory = cat;
            this.remiderDate = date;
            this.remiderCountry = '';
            this.remiderData = null;
            let Payload={
                reminderType:this.remiderCategory,
                reminderDate:this.remiderDate
            };
            if(this.remiderCategory == 'globalStatus'){
                // if(country && country.id){
                //     this.remiderCountry = country;
                //     Payload['countryId'] = this.remiderCountry.id 
                // }
                Payload['globalStatus'] = this.checkProperty(this.petition['overviewInfo'], 'beneficiaryInfo', 'globalStatus')
            }
            let path = '/reminders/get-send-overview';
            this.$store.dispatch('commonAction', {data:Payload, path:path}).then((response)=>{
                // console.log(JSON.stringify(response), 'response')
                if(response){

                    if(this.remiderCategory == 'globalStatus'){
                        if(this.checkProperty(response, 'config') ){
                            if(this.checkProperty(response, 'results') && this.checkProperty(response, 'results', 'length')>0){
                                let tempData =  _.cloneDeep(response);
                                tempData['config'] = _.forEach(response['config'], (itm)=>{
                                    let findObj = _.find(response['results'], {'countryId':itm['countryId']});
                                    if(findObj){
                                        itm['reminder'] = findObj['reminder']
                                    }
                                   
                                })
                               
                                this.remiderData = _.cloneDeep(tempData);
                            }else{
                                this.remiderData = _.cloneDeep(response)
                            }
                           
                           
                        }else{
                            this.remiderData ={
                                config: [{
                                    countryId: null,
                                    countryDetails: null,
                                    config: [
                                        {
                                            days: ''
                                        },
                                    ]
                                }],
                            };
                            this.showDetails = false;
                        }
                        this.updateGlobalCountryList();
                    }else{
                        if(this.checkProperty(response, 'config')){
                            let tempData = response['config'];
                            if(this.checkProperty(tempData, 'whoWillSendReminder') && this.checkProperty(tempData, 'whoWillSendReminder', 'length')>0){
                                let rolesList = [];
                                let roleName = '';
                                tempData['whoWillSendReminder'] = _.forEach(tempData['whoWillSendReminder'], (itm)=>{
                                    itm['id'] = itm['roleId'];
                                    itm['name'] = itm['roleName'];
                                    if(rolesList.indexOf(itm['roleName'])<=-1){
                                        rolesList.push(itm['roleName'])
                                    }
                                })
                                if(rolesList && rolesList.length>0){
                                    roleName = rolesList.join(', ');
                                    tempData['roleName'] = roleName;
                                }
                                
                            }
                            if(this.checkProperty(tempData, 'config') && this.checkProperty(tempData, 'config', 'length')>0){
                                tempData['config'] = _.forEach(tempData['config'], (itm)=>{
                                    itm['showError'] = false;
                                })
                            }
                            this.remiderData = tempData;
                        }else{
                            this.remiderData ={
                                whoWillSendReminder: [],
                                config: [
                                    {
                                        days: '',
                                        showError:false
                                    },
                                ]
                            }
                            this.showDetails = false;
                        }
                    }
                    
                    if(this.checkProperty(response, 'results') && this.checkProperty(response, 'results', 'length')>0){
                        this.reminderCategoryDetails = response['results'];
                        this.showDetails = false;
                    }
                    this.errorMsg = '';
                    this.$modal.show('showReminderDetailsModal');
                }else{
                    if(this.remiderCategory == 'globalStatus'){
                        this.remiderData ={
                            config: [{
                                countryId: null,
                                countryDetails: null,
                                config: [
                                    {
                                        days: '',
                                        showError:false
                                    },
                                ]
                            }],
                        }
                    }else{
                        this.remiderData ={
                            whoWillSendReminder: [],
                            config: [
                                {
                                    days: '',
                                    showError:false
                                },
                            ]
                        }
                    }
                }
            }).catch((err)=>{
                if(err){
                    this.showToster({message:err,isError:true });
                }
            })
        },
        submitForm(){
            this.$validator.validateAll('casedetailsform').then((result) => {
                if(result){
                    let payLoad={
                        userId:this.petitionId,
                        overviewInfo:{
                            beneficiaryInfo:this.beneficiaryInfo
                        }
                    };
                    if(this.checkProperty(this.beneficiaryInfo, 'statusExpiryDate')){
                        payLoad['overviewInfo']['beneficiaryInfo']['isDSExpiryDate'] = false;
                    }
                    if(this.checkProperty(this.beneficiaryInfo, 'statusExpiryDate')){
                        payLoad['overviewInfo']['beneficiaryInfo']['isI94DSExpiryDate'] = false;
                    }
                    let path='/beneficiary-profile/update-overview-info';
                    this.formSubmited = true;
                    this.errorMsg = '';
                    this.$store.dispatch('commonAction', {data:payLoad, path:path}).then((response)=>{
                        this.formSubmited = false;
                        this.showToster({message:response.message,isError:false });
                        this.$emit('reloadPetition', 'overView')
                        
                    }).catch((err)=>{
                        this.formSubmited = false;
                        this.errorMsg = err;
                        this.showToster({message:err,isError:true });
                    })
                }
            })
        },
        checkCurrentStatus(){
            if(!(this.checkProperty(this.beneficiaryInfo, 'currentStatusDetails') && this.checkProperty(this.beneficiaryInfo, 'currentStatusDetails','id')) ){
                this.beneficiaryInfo.statusExpiryDate = null;
                this.beneficiaryInfo.currentStatus = null;
            }
        },
        getUserRoles() {
            let postData = {
                page: 1,
                perpage: 10000,
                category: "user_roles",
            }
            this.$store.dispatch("getMasterData", postData).then(response => {
                let userRolesList = response.list;
                let tempList = [];
                _.forEach(userRolesList, (item) => {
                    tempList.push({
                        roleId: item["id"],
                        roleName: item["name"],
                        id:item["id"],
                        name: item["name"],
                    });
                });
                this.allUserRoles = tempList;
                this.allUserRoles = _.filter(this.allUserRoles, (rol) => {
                    return [1, 2].indexOf(rol['roleId']) <= -1
                })
                if(this.getTenantTypeId==2){
                    this.passportExpiryUserRoles = _.filter(this.allUserRoles, (rol) => {
                    return [3,4,5,6,7,8,9,10,11,12,13,14,51].indexOf(rol['roleId']) > -1
                    })
                    this.i94ExpiryUserRoles = _.filter(this.allUserRoles, (rol) => {
                        return [3,4,5,6,7,8,9,10,11,12,13,14,51].indexOf(rol['roleId']) > -1
                    })
                    this.visaExpiryUserRoles = _.filter(this.allUserRoles, (rol) => {
                        return [3,4,5,6,7,8,9,10,11,12,13,14,51].indexOf(rol['roleId']) > -1
                    })
                    this.workAuthorizationExpiryUserRoles = _.filter(this.allUserRoles, (rol) => {
                        return [3,4,5,6,7,8,9,10,11,12,13,14,51].indexOf(rol['roleId']) > -1
                    })
                }else{
                    this.passportExpiryUserRoles = _.filter(this.allUserRoles, (rol) => {
                    return [50,51].indexOf(rol['roleId']) > -1
                    })
                    this.i94ExpiryUserRoles = _.filter(this.allUserRoles, (rol) => {
                        return [50,51].indexOf(rol['roleId']) > -1
                    })
                    this.visaExpiryUserRoles = _.filter(this.allUserRoles, (rol) => {
                        return [3,4,5,6,7,8,9,10,11,12,13,14,51,50].indexOf(rol['roleId']) > -1
                    })
                    this.workAuthorizationExpiryUserRoles = _.filter(this.allUserRoles, (rol) => {
                        return [3,4,5,6,7,8,9,10,11,12,13,14,51].indexOf(rol['roleId']) > -1
                    })
                }
            })
        },
        updateReminder(){
            this.$validator.validateAll(this.remiderCategory == 'globalStatus'?'globalStatus':'updateForm').then((result) => {
                if(result){
                    let payLoad = {
                        reminderType:this.remiderCategory,
                        // configData:this.remiderData
                    };
                    if(this.remiderCategory == 'globalStatus'){
                        // payLoad['configData'] = [{
                        //         countryId: null,
                        //         countryDetails: null,
                        //         config: [
                        //             {
                        //                 days: ''
                        //             },
                        //         ]
                        //     }]
                        payLoad['configData'] = this.remiderData['config']
                    }else{
                        payLoad['configData'] = this.remiderData
                    }
                    this.loading = true;
                    let path = '/global-config/update-reminders';
                    this.$store.dispatch('commonAction', {data:payLoad, path:path}).then((response)=>{
                        this.loading = false;
                        this.showToster({message:response.message,isError:false });
                        this.$emit('reloadPetition', 'overView')
                        this.$modal.hide('showReminderDetailsModal')
                    }).catch((err)=>{
                        this.loading = false;
                        this.errorMsg = err;
                    })
                }
            })
            
        },
        clearReminder(){
            this.loading = false;
            this.remiderCategory = null;
            this.errorMsg = '';
            this.remiderDate = null;
            this.remiderData = null;
            this.$modal.hide('showReminderDetailsModal')
        },
    },
    directives: {},
    components: {
        fileUploadNote,
      datepickerField,
      selectField,
      immiInput,
      VuePerfectScrollbar,
    },
  };
  </script>